export default __webpack_public_path__ + "static/coin-stack-be8c026cf6cec76fdd53b1abb6368791.svg";